import { useMutation, useQueryClient } from "@tanstack/react-query";

import { variantAttributeKeys } from "./keys";

import { VariantAttribute, CreateVariantAttributePayload } from "@/types/product";
import { Response } from "@/types/pagination";
import { isMockEnabled, simulateDelay } from "@/mock/config";
import { createVariantAttributeMock } from "@/mock/handlers/variant-attribute";

import { api } from "@/lib/api-client";

export const useCreateVariantAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateVariantAttributePayload) => {
      if (isMockEnabled()) {
        await simulateDelay();
        return createVariantAttributeMock(payload);
      }

      const { data } = await api
        .post("variant-attributes", { json: payload })
        .json<Response<VariantAttribute>>();

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: variantAttributeKeys.lists(),
      });
    },
  });
};
